import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import ReactSVG from "react-svg";
import Compressor from "compressorjs";
import CheckCircle from "~/assets/img/icon/check-circle.svg";
import { Text, Margin, Button, Message } from "~/components/elements";
import { getBase64 } from "~/utils/tools";
import * as S from "./styles";


export default function UploadField({
  setFieldValue,
  name,
  errors,
  setFieldTouched,
}) {
  const [rejected, setRejected] = useState(false);

  const {
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject,
    acceptedFiles,
    open,
    onError,
  } = useDropzone({
    maxFiles: 1,
    noClick: true,
    noKeyboard: true,
    maxSize: 5000000,
    accept: {
      "image/jpeg": [".jpeg", ".png"],
      "application/pdf": [".pdf"],
      // "application/*": ['.pdf'],
    },
    onDrop: async (files) => {
      setRejected(false);
      setFieldTouched(name, true, true);
      let file = files[0];

      if (!file) return;
      if (file.type === "application/pdf") {
        const url = URL.createObjectURL(file);
        try {
          const response = await fetch(url);
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          const blob = await response.blob();
          const dataUrl = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => {
              resolve(e.target.result);
            };
            reader.onerror = (e) => {
              reject(e);
            };
            reader.readAsDataURL(blob);
          });

          setFieldValue(name, dataUrl);
        } catch (error) {
          setRejected(true);
          setFieldTouched(name, true);
          setFieldValue(name, "");
        }


      } else {
        new Compressor(file, {
          quality: 0.6,
          success(res) {
            getBase64(res)
              .then((result) => {
                file["base64"] = result;
                setFieldValue(name, file?.base64);
              })
              .catch(() => {
                setRejected(true);
                setFieldTouched(name, true);
                setFieldValue(name, "");
              });
          },
          error() {
            setRejected(true);
            setFieldTouched(name, true);
            setFieldValue(name, "");
          },
        });
      }
    },
    onDropRejected: () => {
      setRejected(true);
      setFieldTouched(name, true);
      setFieldValue(name, "");
    },
    onFileDialogCancel: () => {
      setFieldValue(name, "");
      setRejected(false);
      setFieldTouched(name, true, true);
    },
  });

  const files = acceptedFiles.map((file) => (
    <Text as="strong" level="3" key={file.path}>
      {file.path}
    </Text>
  ));

  // CONVERT TO IMAGE
  // const renderPage = async (data) => {
  //   // setLoading(true);
  //   const imagesList = [];
  //   const canvas = document.createElement("canvas");
  //   // canvas.setAttribute("className", "canv");
  //   const pdf = await pdfjsLib.getDocument({ data }).promise;
  //   for (let i = 1; i <= pdf.numPages; i++) {
  //     var page = await pdf.getPage(i);
  //     var viewport = page.getViewport({ scale: 1.5 });
  //     canvas.height = viewport.height;
  //     canvas.width = viewport.width;
  //     var render_context = {
  //       canvasContext: canvas.getContext("2d"),
  //       viewport: viewport,
  //     };
  //     await page.render(render_context).promise;
  //     let img = canvas.toDataURL("image/png");
  //     imagesList.push(img);
  //   }

  //   console.log("imagesList => ", imagesList);
  //   // setNumOfPages((e) => e + pdf.numPages);
  //   // setImageUrls((e) => [...e, ...imagesList]);
  // };

  return (
    <>
      <S.UploadDropZone
        error={!!errors}
        {...getRootProps({ isFocused, isDragAccept, isDragReject })}
      >
        <input {...getInputProps()} />
        <Margin mb={3}>
          <Text level="2">
          Anexar uma imagem legível do cupom fiscal
          <br className="deskOnly" />
          no formato JPEG, PNG ou PDF.
          </Text>
        </Margin>
        <Margin mb={2}>
          {!files.length ? (
            <Button
              className="animation-size"
              // variant="outlined"
              primary
              id="uploadButtonFormInvoice"
              onClick={open}
            >
              ANEXAR IMAGEM
            </Button>
          ) : (
            <S.FileName>
              <Text level="3">
                {files}
                <ReactSVG src={CheckCircle} />
              </Text>
              <Text level="3" as="anchor" onClick={open}>
                Trocar
              </Text>
            </S.FileName>
          )}
          {onError && <Text level="2">Não foi possível fazer upload</Text>}
        </Margin>

        <Text level="3">Limite tamanho de arquivo - 5MB</Text>
      </S.UploadDropZone>
      {!!errors && (
        <Margin mt={1}>
          <Message variant="error">
            {rejected ? "Arquivo deve conter tamanho máximo de 5MB" : errors}
          </Message>
        </Margin>
      )}
    </>
  );
}
